import { InfoOutlined } from "@ant-design/icons";
import origAddFilled from "@assets/redesign/icons/addFilled.svg";
import inputEdit from "@assets/redesign/icons/inputEdit.svg";
import trash from "@assets/redesign/icons/trash.svg";
import Icon from "@components/global/new/Icon/Icon";
import { MinersTabSelect } from "@components/global/new/MinersTabSelect/MinersTabSelect";
import wlpAddFilled from "@components/WLP202603/assets/redesign/icons/addFilled.svg";
import { MODALS_ENUM } from "@constants/Modals";
import { MinerTabType } from "@services/http/responses/BaseResponse";
import {
  createTabRequest,
  deleteTabRequest,
  renameTabRequest,
} from "@services/vtabs";
import { RootState } from "@store";
import { setTab } from "@store/minersSelect/actions";
import { SpecialTabs, Tab } from "@store/minersSelect/actionTypes";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import useTypedRequest from "@utils/hooks/useTypedRequest";
import { makeNotifs } from "@utils/makeNotifs";
import { Button, Flex, Tooltip } from "antd";
import classNames from "classnames";
import { useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { show } from "redux-modal";
import { WLP202603 } from "../../../../config";
import Search from "../Search/Search";
import { SearchPart } from "../Search/Search.props";
import styles from "./MinerTools.module.scss";

const MINER_SEARCH_STORAGE_KEY = "WATTMANOR:search_storage";
const MINER_SEARCH_UNKNOWN_STORAGE_KEY = "WATTMANOR:search_unknown_storage";
const addFilled = WLP202603 ? wlpAddFilled : origAddFilled;

type MinerToolsProps = {
  className?: string;
  tab?: MinerTabType;
  showConnected?: boolean;
  onSearch: { (search: SearchPart[]): void };
};

function MinerTools(props: MinerToolsProps) {

  const { formatMessage } = useIntl();
  const { onSuccess, onLoader } = useGlobalNotifs();
  const { ok } = makeNotifs();
  const dispatch = useDispatch();
  const curID = useSelector((root: RootState) => root.minersSelect.tab);
  const [currentName, setCurrentName] = useState("");
  const { request: requestCreateTab } = useTypedRequest(createTabRequest);
  const { request: requestDeleteTab } = useTypedRequest(deleteTabRequest);
  const { request: requestRenameTab } = useTypedRequest(renameTabRequest);
  const [key, setKey] = useState(Date.now());

  const createTab = async (name: string) => {
    onLoader(true);
    if (await requestCreateTab(name)) {
      setKey(Date.now());
      onSuccess(ok.success);
    } else {
      onLoader(false);
    }
  };

  const deleteTab = async (id: number) => {
    onLoader(true);
    if (await requestDeleteTab(id)) {
      dispatch(setTab(Tab.ALL));
      setKey(Date.now());
      onSuccess(ok.success);
    } else {
      onLoader(false);
    }
  };

  const renameTab = async (id: number, newName: string) => {
    onLoader(true);
    if (await requestRenameTab(id, newName)) {
      setKey(Date.now());
      onSuccess(ok.success);
    } else {
      onLoader(false);
    }
  };

  return (
    <>
      <Flex
        gap={20}
        align="start"
        className={classNames(styles.wrap, props.className)}
      >
        <Tooltip
          title={
            <ul className={styles.helpSearch}>
              <li>{formatMessage({ id: "search_form.machines.help1" })}</li>
              <li>{formatMessage({ id: "search_form.machines.help2" })}</li>
            </ul>
          }
          color="white"
        >
          <div className={styles.info}>
            <InfoOutlined />
          </div>
        </Tooltip>
        <Search
          storageKey={MINER_SEARCH_STORAGE_KEY}
          save={props.onSearch}
          id="search"
          multicolor
          className={classNames(styles.input, {
            [styles.hidden]: props.tab === "unknown",
          })}
        />
        <Search
          storageKey={MINER_SEARCH_UNKNOWN_STORAGE_KEY}
          save={props.onSearch}
          className={classNames(styles.input, {
            [styles.hidden]: props.tab !== "unknown",
          })}
        />
        <div className={styles.tabSelect}>
          <MinersTabSelect
            key={key}
            showConnected={props.showConnected}
            className={styles.selectStatus}
            label={
              <Flex justify="space-between" align="center">
                <span>
                  {formatMessage({ id: "machines.table.tabs.select.title" })}
                </span>
                {
                  <Flex
                    align="center"
                    gap={3}
                    className={styles.addStatus}
                    onClick={() => {
                      dispatch(
                        show(MODALS_ENUM.ADD_MINERS_TABLE_TAB, {
                          submit: createTab,
                        })
                      );
                    }}
                  >
                    <Icon
                      src={addFilled}
                      className={styles.addStatusIcon}
                      noHover
                    />
                    <span>
                      {formatMessage({
                        id: "machines.table.tabs.select.addStatus",
                      })}
                    </span>
                  </Flex>
                }
              </Flex>
            }
            value={curID}
            onChange={(value, name) => {
              dispatch(setTab(value));
              setCurrentName(name);
            }}
          />
          {!SpecialTabs.find((item) => item.id === curID) && (
            <div className={styles.sectionControls}>
              <Button
                type="text"
                onClick={() => {
                  dispatch(
                    show(MODALS_ENUM.ADD_MINERS_TABLE_TAB, {
                      tabName: currentName,
                      submit: (name: string) => renameTab(curID, name),
                    })
                  );
                }}
              >
                <img src={inputEdit} alt="" />
              </Button>
              <Button
                type="text"
                onClick={() => {
                  dispatch(
                    show(MODALS_ENUM.CONFIRM_MODAL, {
                      onConfirm: () => deleteTab(curID),
                    })
                  );
                }}
              >
                <img src={trash} alt="" />
              </Button>
            </div>
          )}
        </div>
      </Flex>
    </>
  );
}

export { MinerTools };
